
<div class="privacy-policy">

	<h2>UVexplorer Server Privacy Policy</h2>

	<hr />

	<p>
		Effective as of March 4, 2022
	</p>

	<p>
		This page informs you of our policies regarding the collection, use and disclosure of Personal Information we
		receive from users of UVexplorer Server (https://uvexplorer.com/uvxserver), hereafter referred to as the �Product�.
	</p>

	<p>
		We use a small amount of Personal Information when necessary to implement features of the Product.
		By using the Product, you agree to the collection and use of information in accordance with this policy.
	</p>

	<h3>Cookies</h3>

	<p>
		Cookies are files with a small amount of data. Cookies are sent to your browser from the Product and stored
		on your computer's hard drive.
	</p>

	<p>
		The Product uses "cookies" to store an anonymous unique session identifier.
	</p>

	<p>
		You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
		However, if you do not accept cookies, you may not be able to use the Product.
	</p>

	<h3>User Accounts and User Groups</h3>

	<p>
		The Product requires administrators to create user accounts for people who require access to the Product.
		When a user account is created, the administrator enters a small amount of personal information including
		the person�s name and email address. This information is stored in the Product�s database in an encrypted
		form so it cannot be read by someone who gains access to the Product�s database.
	</p>

	<h3>Google Workspace User Accounts and User Groups</h3>

	<p>
		The Product allows administrators to create user accounts that are tied to existing Google Workspace accounts.
		This allows users to access the Product using their Google Workspace account credentials, and removes the need
		for the Product to store passwords in its database.
	</p>

	<p>
		The Product also allows administrators to create user groups that are tied to existing Google Workspace user groups.
		This allows administrators to reuse groups already created in Google Workspace, and manage group membership through
		Google Workspace.
	</p>

	<h4>The Information We Collect</h4>

	<p>
		When creating user accounts, the Product retrieves a small amount of personal information from Google using the Google Directory API, including:
	</p>
	<ol>
		<li>Google user login names</li>
		<li>Google user email addresses</li>
		<li>Google user account identifiers</li>
	</ol>

	<p>
		When creating user groups, the Product retrieves a small amount of group information from Google using the Google Directory API, including:
	</p>
	<ol>
		<li>Google group identifiers</li>
		<li>Google group names</li>
		<li>Google group member identifiers (users and groups)</li>
	</ol>

	<h4>How We Use Your Information</h4>

	<p>
		Google user account information is used to connect UVexplorer Server user accounts with their corresponding Google user accounts.
	</p>

	<p>
		Google user group information is used to connect UVexplorer Server user groups with their corresponding Google user groups.
	</p>

	<h4>How We Store Your Information</h4>

	<p>
		Collected Google user account and user group information is stored in the Product�s database.
		It is stored in an encrypted form so it cannot be read by someone who gains access to the Product�s database.
	</p>

	<h4>How We Share Your Information</h4>

	<p>
		We do not share your Google information with anyone.
	</p>

	<h3>Active Directory User Accounts and User Groups</h3>

	<p>
		The Product allows administrators to create user accounts that are tied to existing Active Directory accounts.
		This allows users to access the Product using their Active Directory account credentials, and removes the
		need for the Product to store passwords in its database.
	</p>

	<p>
		The Product also allows administrators to create user groups that are tied to existing Active Directory user groups.
		This allows administrators to reuse groups already created in Active Directory, and manage group membership through
		Active Directory.
	</p>
	<h4>The Information We Collect</h4>

	<p>
		When creating user accounts, the Product retrieves a small amount of personal information from Google using the Google Directory API, including:
	</p>
	<ol>
		<li>Active Directory user login names</li>
		<li>Active Directory user email addresses</li>
		<li>Active Directory user account identifiers</li>
	</ol>

	<p>
		When creating user groups, the Product retrieves a small amount of group information from Google using the Google Directory API, including:
	</p>
	<ol>
		<li>Active Directory group identifiers</li>
		<li>Active Directory group names</li>
		<li>Active Directory group member identifiers (users and groups)</li>
	</ol>

	<h4>How We Use Your Information</h4>

	<p>
		Active Directory user account information is used to connect UVexplorer Server user accounts with their corresponding Active Directory user accounts.
	</p>

	<p>
		Active Directory user group information is used to connect UVexplorer Server user groups with their corresponding Active Directory user groups.
	</p>

	<h4>How We Store Your Information</h4>

	<p>
		Collected Active Directory user account and user group information is stored in the Product�s database.
		It is stored in an encrypted form so it cannot be read by someone who gains access to the Product�s database.
	</p>

	<h4>How We Share Your Information</h4>

	<p>
		We do not share your Active Directory information with anyone.
	</p>

	<h3>Security</h3>

	<p>
		The security of your Personal Information is important to us, but remember that no method of transmission
		over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially
		acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
	</p>

	<h3>Changes To This Privacy Policy</h3>

	<p>
		This Privacy Policy is effective as of March 4, 2022 and will remain in effect except with respect to any
		changes in its provisions in the future, which will be in effect immediately after being posted on this page.
	</p>

	<p>
		We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy
		periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this
		page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the
		modified Privacy Policy.
	</p>

	<p>
		If we make any material changes to this Privacy Policy, we will notify you either through the email address you
		have provided us, or by placing a prominent notice on our website.
	</p>

	<h3>Contact Us</h3>

	<p>
		If you have any questions about this Privacy Policy, please contact us at sales&#64;uvnets.com.
	</p>

	<hr />

	<p>
		&copy; 2022 UVnetworks LLC. All rights reserved.
	</p>

</div>
